import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { ZoneConfigService } from '../services/zone-config.service';
import { ZoneStateService } from '../services/zone-state.service';

export const zoneInterceptor: HttpInterceptorFn = (req, next) => {
  const zoneConfig = inject(ZoneConfigService);
  const zoneState = inject(ZoneStateService);

  if (!zoneConfig.enabled) {
    return next(req);
  }

  const activeZone = zoneState.activeZone();

  if (!activeZone) {
    return next(req);
  }

  return next(
    req.clone({
      setHeaders: { 'X-Zone-Id': String(activeZone.id) },
    }),
  );
};
